var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validate-wrap"},[_c('modal',{key:_vm.componentResetKey,attrs:{"transition-name":"fade-side","appear":"","logo":_vm.showLogo,"comp":_vm.modalComponent,"handle-props":_vm.modalProps2,"handle-events":_vm.modalEvents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }